import { ActionIcon, Group, Text, Tooltip } from '@mantine/core';
import { IconRefresh } from '@tabler/icons-react';
import dayjs from 'dayjs';
import { i18nKeys, useTranslation } from 'locales';
import { toLowerCase } from 'remeda';
import { useAgedBalancesSubscription } from 'shared/hooks/use-aged-balances-subscription';
import { useLoadAgedBalanceCompact } from 'shared/hooks/use-load-aged-balance';
import { useRefreshBalance } from 'shared/hooks/use-refresh-balance';

export const UpdatedAt = () => {
  const { t } = useTranslation();
  const { agedBalanceCompact } = useLoadAgedBalanceCompact();
  const { refreshBalance } = useRefreshBalance();
  useAgedBalancesSubscription();

  if (agedBalanceCompact == null) return null;

  return (
    <Group>
      <Text size="sm" c="gray.5" fs="italic">
        {t(i18nKeys.ANALYTICS.LAST_UPDATED)}
        {toLowerCase(dayjs(agedBalanceCompact.computedAt).calendar().toLowerCase())}
      </Text>
      <Tooltip withArrow label={t(i18nKeys.ANALYTICS.REFRESH_BALANCE)} arrowSize={7}>
        <ActionIcon onClick={() => refreshBalance()} color="gray" size="sm" variant="light">
          <IconRefresh />
        </ActionIcon>
      </Tooltip>
    </Group>
  );
};
